import React from 'react';
import dabaduIcon from 'assets/images/header-logo.png';

import './header.scss';

const Header: React.FC = () => {
  return (
    <div className='showcase-header'>
      <img src={dabaduIcon} alt='Dabadu' className='img-fluid' />
    </div>
  );
};

export default Header;
